import {
  ChatCircleDots,
  Gear,
  GearSix,
  SignOut,
  User,
} from "phosphor-react";



const Nav_Buttons = [
  {
    index: 0,
    icon: <ChatCircleDots />,
  },

];

const Nav_Setting = [
  {
    index: 3,
    icon: <GearSix />,
  },
];







const Message_options = [
  {
    title: "Reply",
  },
  {
    title: "React to message",
  },
  {
    title: "Forward message",
  },
  {
    title: "Star message",
  },
  {
    title: "Report",
  },
  {
    title: "Delete Message",
  },
];



export {
  Nav_Setting,
  Nav_Buttons,
  Message_options,
};
